import ApplicantManual from '@/components/services/TransferElDocs/Applicant/Manual/index.vue';

import Addressee from '@/components/services/TransferElDocs/Addressee/index.vue';
import AccountBankDetails from '@/components/services/TransferElDocs/AccountBankDetails.vue';
import StepDocuments from '@/components/services/common/StepDocuments.vue';

import SelectSubjectFillType from '@/components/services/common/SelectSubjectFillType.vue';
import SubjectFillType from '@/components/services/common/SubjectFillType.vue';

import { isMrpaEnable } from '@/app.config';
import { StatementType } from '@/constants';

const commonSteps: unknown[] = [Addressee, AccountBankDetails, StepDocuments];
const steps: unknown[] = [ApplicantManual, ...commonSteps];

const mrpaSteps: unknown[] = [
  SelectSubjectFillType,
  SubjectFillType,
  ...commonSteps,
];

export const transferElDocsSteps: unknown[] = isMrpaEnable(StatementType.TRANSFER_EL_DOCS) ? mrpaSteps : steps;
